<script>
    import { onMount } from "svelte";

    import { _ } from "svelte-i18n";
    import Loader from "components/Loader.svelte";
    import { getData, putData } from "utils/ApiUtils.svelte";

    import { dynamicSort } from "utils/FormatUtils.svelte";
    import DragDropList from "components/DragDropList.svelte";

    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    export let courseId;

    onMount(async () => {
        // eslint-disable-next-line no-unused-vars
        loadData();
    });

    let items;
    let status = "loading";

    function loadData() {
        status = "loading";
        getLessons();
    }

    function getLessons() {
        status = "loading";
        if (courseId) {
            getData(`api/courses/${courseId}/lessons/projection`)
                .then((data) => {
                    console.log("lessons successful", data);

                    items = data;
                    items.sort(dynamicSort("customOrder"));

                    status = "ok";
                })
                .catch((error) => {
                    status = "error";
                    console.log("error lessons", error);
                });
        }
    }

    function handleOrderChanged(event) {
        // Update the parent's items array with the new order
        items = event.detail.items;
        console.log("New order:", items);
    }

    function updateData() {
        status = "loading";

        let orderList = {
            order: items.map((i) => {
                return i.lessonId;
            }),
        };

        putData(
            `api/courses/${courseId}/lessons/reorder`,
            orderList,
        )
            .then((dataResult) => {
                console.log("exercises successful", dataResult);
                dispatch("changeOrder");
            })
            .catch((error) => {
                console.log("error exercises", error);
                status = "error";
                throw new Error("XYX");
            });
    }

    function sortBy(propertyName) {
        items = items.sort(dynamicSort(propertyName, 1));
    }

    function cancel() {
        dispatch("cancel");
    }
</script>

<div>
    <button class="btn btn-primary s-button-primary" on:click={updateData}
        >{$_("SAVE")}</button
    >
    <button class="btn btn-danger s-button-danger" on:click={cancel}
        >{$_("CANCEL")}</button
    >

    
    <button class="btn btn-secondary s-button-secondary" on:click={() => sortBy("lessonName")}
        >{$_("SORT_BY_NAME")}</button
    >
    <button class="btn btn-secondary s-button-secondary" on:click={() => sortBy("activeDateStart")}
        >{$_("SORT_BY_START_DATE")}</button
    >
    <button class="btn btn-secondary s-button-secondary" on:click={() => sortBy("activeDateEnd")}
        >{$_("SORT_BY_END_DATE")}</button
    >
</div>

<div>
    {#if status === "loading"}
        <Loader />
    {:else if status === "error"}{$_("ERROR_LOADING_LESSON_LIST")}
    {:else if status === "ok"}
        <DragDropList
            {items}
            displayProperty="lessonName"
            idProperty="lessonId"
            on:orderChanged={handleOrderChanged}
        >
            <div slot="item" let:item>
                <strong>{item.lessonName}</strong> –

                {#if item?.activeDateStart}
                    {new Date(
                        Date.parse(item?.activeDateStart),
                    ).toLocaleString()}{/if} --- {#if item?.activeDateEnd}{new Date(
                        Date.parse(item?.activeDateEnd),
                    ).toLocaleString()}{/if}
            </div>
        </DragDropList>
    {:else if status === "error"}Error{/if}
</div>
